






















import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import router from '../router'
import { Auth } from 'aws-amplify'

@Component
export default class Toolbar extends Vue {
  get isRoot (): boolean {
    return this.$route.path === '/'
  }

  get user (): string {
    const loginUser = this.$store.getters.user
    return loginUser !== undefined ? loginUser.username : ''
  }

  async logout () {
    console.log('logout!')
    Auth.signOut()
      .then((data: any) => {
        console.log('sign out', data)
        router.push({ path: '/' })
      })
      .catch((e: any) => {
        console.log(e)
      })
  }

  get isManager () {
    console.log(
      'isManager: ',
      this.$store.getters.isManager
    )
    return this.$store.getters.isManager
  }
}
